<template>
  <div>
    <!-- Desktop Footer -->
    <footer class="desktop-footer">
      <div class="footer-container">
        <div class="footer-grid">
          <div class="footer-brand">
            <div class="logo-container">
              <span class="logo-text">OVVURA</span>
            </div>
            <p class="brand-description">
              Founded in the UAE, Ovvura is poised to make a global impact, connecting a network of elite service providers with discerning clients worldwide. Join our rapidly expanding community of best-in-class professionals and clients, and experience the future of healthy and wellness today.
            </p>
            <div class="social-links">
              <a href="https://www.instagram.com/ovvura/" target="_blank" class="social-icon">
                <i class="mdi mdi-instagram"></i>
              </a>
              <a href="https://x.com/ovvura" target="_blank" class="social-icon">
                <i class="mdi mdi-twitter"></i>
              </a>
              <a href="https://www.youtube.com/@ovvura" target="_blank" class="social-icon">
                <i class="mdi mdi-youtube"></i>
              </a>
              <a href="https://www.tiktok.com/@ovvura?lang=en" target="_blank" class="social-icon">
                <i class="fab fa-tiktok"></i>
              </a>
            </div>
          </div>

          <div class="footer-links">
            <h4 class="links-title">Quick Links</h4>
            <ul>
              <li><router-link to="/">Home</router-link></li>
              <li><router-link to="/aboutus">About</router-link></li>
              <li><router-link to="/products">Services</router-link></li>
              <li><router-link to="/shops">Providers</router-link></li>
              <li><router-link to="/about">About Us</router-link></li>
            </ul>
          </div>

          <div class="footer-links">
            <h4 class="links-title">Legal</h4>
            <ul>
              <li><router-link to="/contact">Contact Us</router-link></li>
              <li><router-link to="/faq">FAQs</router-link></li>
              <li><router-link to="/pp">Privacy Policy</router-link></li>
              <li><router-link to="/tc">Terms & Conditions</router-link></li>
              <li><router-link to="/cp">Cookie Policy</router-link></li>
            </ul>
          </div>

          <div class="footer-apps">
            <h4 class="links-title">Get Our App</h4>
            <div class="app-badges">
              <a href="#" class="app-badge">
                <img src="@/assets/images/googleplay.png" alt="Get on Google Play">
              </a>
              <a href="#" class="app-badge">
                <img src="@/assets/images/appstore.png" alt="Download on the App Store">
              </a>
            </div>
            <div class="contact-info">
              <p><i class="mdi mdi-email-outline"></i> info@ovvura.ae</p>
              <p><i class="mdi mdi-map-marker-outline"></i> Dubai, United Arab Emirates</p>
            </div>
          </div>
        </div>

        <div class="footer-bottom">
          <div class="copyright">
            &copy; {{ new Date().getFullYear() }} OVVURA. All rights reserved.
          </div>
        </div>
      </div>
    </footer>

    <!-- Mobile Bottom Navigation -->
    <nav class="mobile-nav">
      <router-link to="/" class="nav-item">
        <i class="mdi mdi-home"></i>
        <span>Home</span>
      </router-link>
      <router-link to="/products" class="nav-item">
        <i class="mdi mdi-cube"></i>
        <span>Services</span>
      </router-link>
      <router-link to="/shops" class="nav-item">
        <i class="mdi mdi-account-cog"></i>
        <span>Providers</span>
      </router-link>
      <template v-if="token">
        <router-link to="/dashboard" class="nav-item">
          <i class="mdi mdi-account-circle"></i>
          <span>Account</span>
        </router-link>
      </template>
      <template v-else>
        <router-link to="/login" class="nav-item">
          <i class="mdi mdi-login"></i>
          <span>Login</span>
        </router-link>
      </template>
    </nav>
  </div>
</template>

<script>
export default {
  data() {
    return {
      userData: JSON.parse(localStorage.getItem("user")),
      token: localStorage.getItem("token")
    }
  }
}
</script>

<style scoped>
/* Color Variables */
:root {
  --primary: #564ab1;
  --primary-dark: #453d8f;
  --primary-light: #6f65c2;
  --text-light: rgb(255, 255, 255);
  --text-lighter: rgba(255, 255, 255, 0.6);
  --white: #ffffff;
  --transition: all 0.3s ease;
}

/* Desktop Footer */
.desktop-footer {
  background-color: var(--primary);
  color: var(--white);
  padding: 60px 0 20px;
  font-family: 'Poppins', sans-serif;
}

.footer-container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 20px;
}

.footer-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
  gap: 40px;
  margin-bottom: 40px;
}

.footer-brand {
  max-width: 300px;
}

.logo-container {
  margin-bottom: 20px;
}

.logo-text {
  font-size: 28px;
  font-weight: 700;
  letter-spacing: 1px;
}

.brand-description {
  font-size: 14px;
  line-height: 1.6;
  color: var(--white);
  margin-bottom: 25px;
}

.social-links {
  display: flex;
  gap: 15px;
}

.social-icon {
  color: var(--white);
  font-size: 20px;
  transition: var(--transition);
}

.social-icon:hover {
  color: var(--text-light);
  transform: translateY(-3px);
}

.links-title {
  font-size: 18px;
  font-weight: 600;
  margin-bottom: 20px;
  position: relative;
  padding-bottom: 10px;
  color: #fff;
}

.links-title::after {
  content: '';
  position: absolute;
  bottom: 0;
  left: 0;
  width: 40px;
  height: 2px;
  background: var(--white);
}

.footer-links ul {
  list-style: none;
  padding: 0;
}

.footer-links li {
  margin-bottom: 12px;
}

.footer-links a {
  color: var(--white);
  text-decoration: none;
  font-size: 14px;
  transition: var(--transition);
  display: inline-block;
}

.footer-links a:hover {
  color: var(--white);
  transform: translateX(5px);
}

.footer-apps {
  display: flex;
  flex-direction: column;
}

.app-badges {
  display: flex;
  flex-direction: column;
  gap: 10px;
  margin-bottom: 25px;
}

.app-badge {
  display: block;
  max-width: 150px;
  transition: var(--transition);
}

.app-badge:hover {
  transform: translateY(-3px);
}

.app-badge img {
  width: 100%;
  height: auto;
  border-radius: 6px;
}

.contact-info {
  margin-top: auto;
}

.contact-info p {
  font-size: 14px;
  color: var(--white);
  margin-bottom: 10px;
  display: flex;
  align-items: center;
  gap: 8px;
}

.footer-bottom {
  border-top: 1px solid rgba(255, 255, 255, 0.1);
  padding-top: 20px;
  text-align: center;
}

.copyright {
  font-size: 13px;
  color: var(--white);
}

/* Mobile Navigation */
.mobile-nav {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  background: var(--primary);
  display: flex;
  justify-content: space-around;
  padding: 10px 0;
  box-shadow: 0 -2px 10px rgba(0, 0, 0, 0.1);
  z-index: 1000;
  display: none;
}

.nav-item {
  display: flex;
  flex-direction: column;
  align-items: center;
  color: var(--white);
  text-decoration: none;
  font-size: 10px;
  transition: var(--transition);
  padding: 5px 10px;
  border-radius: 8px;
}

.nav-item i {
  font-size: 20px;
  margin-bottom: 4px;
}

.nav-item span {
  font-size: 12px;
}

.nav-item.router-link-exact-active {
  background: rgba(255, 255, 255, 0.15);
}

/* Responsive Design */
@media (max-width: 992px) {
  .footer-grid {
    grid-template-columns: repeat(2, 1fr);
  }
}

@media (max-width: 768px) {
  .desktop-footer {
    padding-bottom: 80px;
  }
  
  .mobile-nav {
    display: flex;
  }
}

@media (max-width: 576px) {
  .footer-grid {
    grid-template-columns: 1fr;
    gap: 30px;
  }
  
  .footer-brand {
    max-width: 100%;
  }
  
  .app-badges {
    flex-direction: row;
    max-width: 300px;
  }
}
</style>